import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/AuthSlice';
import caseStudyReducer from './reducers/CaseStudySlice';

const authPersistConfig = {
  key: 'auth',
  storage,
};

const caseStudiesPersistConfig = {
  key: 'caseStudies',
  storage,
  blacklist: ['loading', 'error'],
};

const rootReducer = {
  auth: persistReducer(authPersistConfig, authReducer),
  caseStudies: persistReducer(caseStudiesPersistConfig, caseStudyReducer),
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
